export default __webpack_public_path__ + "static/hero-5430913497a4bc81cbd20747a26abaa5.webp";